var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWebTranslHomepageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.79632 12.0555C2.72766 10.2741 3.71822 8.741 5.40792 8.1729C7.97314 7.31043 12.7903 6.03672 21.3351 4.76897C29.8798 3.50122 34.8594 3.32141 37.5645 3.40193C39.3464 3.45497 40.7394 4.63446 41.1909 6.35899C41.7767 8.59657 42.6201 12.4561 43.5523 18.7394C44.4845 25.0227 44.798 28.9608 44.8871 31.2721C44.9558 33.0534 43.9652 34.5865 42.2755 35.1546C39.7103 36.0171 34.8931 37.2908 26.3483 38.5586C17.8036 39.8263 12.8241 40.0061 10.1189 39.9256C8.3371 39.8725 6.94408 38.6931 6.49259 36.9685C5.90678 34.731 5.06338 30.8715 4.13115 24.5882C3.19892 18.3048 2.88541 14.3667 2.79632 12.0555Z",
    fill: "#6491CF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.53925 12.5543C5.72805 10.7948 6.90475 9.42209 8.64346 9.09302C11.3071 8.5889 16.284 8 25 8C33.716 8 38.6929 8.5889 41.3565 9.09302C43.0953 9.42209 44.2719 10.7948 44.4607 12.5543C44.7179 14.9506 45 19.1423 45 26C45 32.8577 44.7179 37.0494 44.4607 39.4457C44.2719 41.2052 43.0953 42.5779 41.3565 42.907C38.6929 43.4111 33.716 44 25 44C16.284 44 11.3071 43.4111 8.64345 42.907C6.90475 42.5779 5.72805 41.2052 5.53925 39.4457C5.28211 37.0494 5 32.8577 5 26C5 19.1423 5.28211 14.9506 5.53925 12.5543Z",
    fill: "#DCE2F5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1167 17.4841C25.1992 16.3137 25.9714 15.411 27.1344 15.2562C28.1606 15.1196 29.7124 15 32 15C34.2876 15 35.8394 15.1196 36.8656 15.2562C38.0286 15.411 38.8008 16.3137 38.8833 17.4841C38.947 18.3885 39 19.686 39 21.5C39 23.314 38.947 24.6115 38.8833 25.5159C38.8008 26.6863 38.0286 27.589 36.8656 27.7438C35.8394 27.8804 34.2876 28 32 28C29.7124 28 28.1606 27.8804 27.1344 27.7438C25.9714 27.589 25.1992 26.6863 25.1167 25.5159C25.053 24.6115 25 23.314 25 21.5C25 19.686 25.053 18.3885 25.1167 17.4841Z",
    fill: "#6491CF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11 17C11 15.8954 11.8954 15 13 15H19C20.1046 15 21 15.8954 21 17C21 18.1046 20.1046 19 19 19H13C11.8954 19 11 18.1046 11 17Z",
    fill: "#6491CF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11 26C11 24.8954 11.8954 24 13 24H19C20.1046 24 21 24.8954 21 26C21 27.1046 20.1046 28 19 28H13C11.8954 28 11 27.1046 11 26Z",
    fill: "#6491CF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11 35C11 33.8954 11.8954 33 13 33H37C38.1046 33 39 33.8954 39 35C39 36.1046 38.1046 37 37 37H13C11.8954 37 11 36.1046 11 35Z",
    fill: "#6491CF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebTranslHomepageIcon);
export default __webpack_public_path__ + "static/media/webTranslHomepageIcon.4a72cdbcdf24d6d5ea51c0fbe7206091.svg";
export { ForwardRef as ReactComponent };